import { OverlayDrawerProps } from '@sharefiledev/sharefile-appshell';

type OverlayDrawerConfig = {
	isFullScreen?: boolean;
	baseClassName: string;
};

const fullScreenProps = {
	height: '100%',
	placement: 'bottom' as const,
};

const nonFullScreenProps = {
	width: '90%',
	placement: 'right' as const,
};

export const getOverlayDrawerProps = ({
	isFullScreen = true,
	baseClassName,
}: OverlayDrawerConfig) => {
	const overlayDrawerProps: OverlayDrawerProps = {
		className: baseClassName,
		maskClosable: false,
		styles: { body: { padding: 0 } },
		zIndex: 1000, // This is the default value of antd Drawer. We are setting it here to override the default value set in appshell for registerDrawer.
		...(isFullScreen ? fullScreenProps : nonFullScreenProps),
	};

	return overlayDrawerProps;
};
